import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberTitleForm from '../../../components/forms/MemberTitleForm';
import { useCreateMemberTitle } from '../../../hooks/useMemberTitleApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { MemberTitleDTO } from '../../../services/apiClient';

const MemberTitleCreate: React.FC = () => {
  const createMutation = useCreateMemberTitle();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Titles', href: '/admin/membertitles' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: MemberTitleDTO) => {
    try {
      await createMutation.mutateAsync(data);
      navigate('/admin/membertitles');
    } catch (error) {
      console.error('Error creating MemberTitle:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/membertitles"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.MemberTitle.Edit'
    >
        <MemberTitleForm
          initialValues={{} as MemberTitleDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/membertitles')}
        />
    </AdminLayout>
  );
};

export default MemberTitleCreate;